import type { Environment } from '../../../environments/environment.interface';

export const COOKIE_AUTH_TOKEN_DOMAIN = '.datanyze.com';

// Factory functions to get config values
export function getAuthTokenKeyName(appConfig: Environment): string {
  return appConfig.auth_cookie;
}

export function getNotificationCookie(appConfig: Environment): string {
  return appConfig.dn_noti_cookie;
}

// Factory function to get authentication config
export function getAuthenticationConfig(appConfig: Environment) {
  return {
    authTokenKeyName: getAuthTokenKeyName(appConfig),
    notificationCookie: getNotificationCookie(appConfig),
    cookieAuthTokenDomain: COOKIE_AUTH_TOKEN_DOMAIN,
  };
}
